export const listAssignableApplications = `
    query listAssignableApplications($input: listAssignableAssignedApplicationsInput!) {
        listAssignableApplications(input: $input) {
            reviewer {
                id
                isActive
                nameN
                isAdmin
                programId
                firstName
                lastName
                assignableApplications
            }
             columns 
            totalCount
        }
    }
`;

export const listAssignedApplications = `
    query listAssignedApplications($input: listAssignableAssignedApplicationsInput!) {
        listAssignedApplications(input: $input) {
            reviewer {
                id
                isActive
                nameN
                isAdmin
                programId
                firstName
                lastName
                assignedApplications 
            }
            columns 
            totalCount
        }
    }
`;

export const bulkAssignUnassignApplications = `
    mutation bulkAssignUnassignApplications($applicationKeys: [ApplicationKeyInput!]!, $reviewerEmployeeId: String!, $completedByDueDate: String!, $actionType: AssignUnassignActionType!) {
        bulkAssignUnassignApplications(applicationKeys: $applicationKeys, reviewerEmployeeId: $reviewerEmployeeId, completedByDueDate: $completedByDueDate, actionType: $actionType) {
            status
            successDetails
            errorDetails
        }
    }
`;